import {
    useTheme, 
    useMediaQuery,
    Box,
} from '@mui/material';
import StatusToggle from './StatusToggle';
import PeriodToggle from './PeriodToggle';
import { PerPageSwitcher } from '../../../';
import { ExpansionToggle } from '../../../../../general';

const RedirectsHistoryTopBarFilters = props => {

    const {
        isExpanded,
        setExpansion,
        historyPeriods,
        redirectStatuses,
    } = props;

    const {
        perPage,
        status,
        period,
    } = props.settings;

    const {
        setPerPage,
        setStatus,
        setPeriod,
    } = props.setMethods;

    const theme = useTheme();

    const matchesDownMd = useMediaQuery(theme.breakpoints.down('md'));
    const matchesDownSm = useMediaQuery(theme.breakpoints.down('sm'));
    const matchesDown700 = useMediaQuery(theme.breakpoints.down(700));
    const matchesDown500 = useMediaQuery(theme.breakpoints.down(500));

    const tooLongFilterValues = (status && status.length >= 20) || (period && period.length >= 5);

    const columnFilterOptions = matchesDown500 && tooLongFilterValues;

    const columnTopBarOptions = (matchesDown700 && tooLongFilterValues) || matchesDownSm;

    return (
        <Box sx={{
            display: 'flex', 
            flexDirection: columnTopBarOptions ? 'column' : 'row', 
            alignItems: matchesDownMd ? 'flex-start' : 'center', 
            gap: columnTopBarOptions ? 1.5 : 1,
        }}>
            <Box sx={{
                display: 'flex',
                flexDirection: columnFilterOptions ? 'column' : 'row',
                gap: columnFilterOptions ? 1.5 : 1,
            }}>
                {
                    redirectStatuses.length > 1 &&
                    <StatusToggle 
                        status={status} 
                        setStatus={setStatus}
                        redirectStatuses={redirectStatuses}
                    />
                }
                {
                    historyPeriods.length > 1 &&
                    <PeriodToggle 
                        period={period}
                        setPeriod={setPeriod}
                        historyPeriods={historyPeriods}
                    />
                }
            </Box>
            <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                <ExpansionToggle 
                    isExpanded={isExpanded}
                    setExpansion={setExpansion}
                    forRedirects={true}
                />
                <PerPageSwitcher
                    perPage={perPage}
                    setPerPage={setPerPage}
                    fixedMinWidth={true}
                />
            </Box>
        </Box>
    );
}

export default RedirectsHistoryTopBarFilters;